import Head from "next/head";
import { appName, getPublicRuntimeConfig } from "../../config";

interface IProps {
  metaDescription?: string;
  metaTitle?: string;
  metaUrl?: string;
}

export default function Seo({
  metaDescription,
  metaTitle = `${appName} | MaintainX`,
  metaUrl,
}: IProps) {
  const { frontendUrl } = getPublicRuntimeConfig();

  return (
    <Head>
      <meta charSet="utf-8" />
      <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      <title>{metaTitle}</title>
      <meta itemProp="name" content={metaTitle} />
      <meta name="og:title" content={metaTitle} />
      <meta name="og:image" content={`${frontendUrl}/maintainx-global-procedure-library.png`} />
      <meta name="og:image:width" content="1200" />
      <meta name="og:image:height" content="630" />
      <meta name="og:site_name" content={`${appName} | MaintainX`} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:site" content="@maintainx" />
      <meta
        name="twitter:image:src"
        content={`${frontendUrl}/maintainx-global-procedure-library.png`}
      />
      {!!metaDescription && (
        <>
          <meta name="description" content={metaDescription} />
          <meta itemProp="description" content={metaDescription} />
          <meta name="og:description" content={metaDescription} />
          <meta name="twitter:description" content={metaDescription} />
        </>
      )}
      {!!metaUrl && (
        <>
          <link rel="canonical" href={metaUrl} />
          <meta property="og:url" content={metaUrl} />
        </>
      )}
      <link
        rel="icon"
        type="image/png"
        href={
          process.env.NODE_ENV === "development"
            ? `${frontendUrl}/FavIconDev64.png`
            : `${frontendUrl}/FavIcon64.png`
        }
      />
    </Head>
  );
}
